import React, { Suspense, memo, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as AllParts from 'components/SwitchAndGauge/parts-components'
import withStyle from './LocationShape.style'

const regex = /-/gi

// Part_Shape_{dash type}_{detail}_{panel}?
export function findLocationShape(dashboardType, detail, panel) {
  // WW2614 AU250: R/AA is the 146x486 RAM cutout stored as R_A_A (PBI pending).
  const shapeDetail = dashboardType === 'R' && detail === 'AA' ? 'A-A' : detail
  const detailAdjustToFileName = shapeDetail
    ? shapeDetail.replaceAll(regex, '_')
    : shapeDetail
  if (
    `Part__Shape_${dashboardType}_${detailAdjustToFileName}_${panel}` in
    AllParts
  ) {
    return AllParts[
      `Part__Shape_${dashboardType}_${detailAdjustToFileName}_${panel}`
    ]
  }
  return AllParts[`Part__Shape_${dashboardType}_${detailAdjustToFileName}`]
}

function logMissingShape(dashboardType, detail) {
  /* eslint-disable-next-line no-console */
  console.log(`Shape not found for ${dashboardType} ${detail}`)
}

const LocationShape = ({ detail, dashboardType, panel, style }) => {
  const Shape = findLocationShape(dashboardType, detail, panel)
  useEffect(() => {
    if (!Shape) logMissingShape(dashboardType, detail)
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])
  if (!Shape) {
    return <></>
  }

  return (
    <Suspense fallback={<></>}>
      <Shape {...{ style }} />
    </Suspense>
  )
}

LocationShape.propTypes = {
  dashboardType: PropTypes.string,
  detail: PropTypes.string,
  panel: PropTypes.string,
  isSelected: PropTypes.bool,
  style: PropTypes.object,
}

export default memo(withStyle(LocationShape))
